import $ from 'jquery';

//import Common from '../common/base/common';
import Layout from './base/layout';
import Analytics from './analytics/analytics';

// Shared Components
import '../common/components/banner';
import './components/modal';
import '../common/components/webpimages';
import '../common/components/lazyload';
import './components/modal-change-location';
import './components/agent-image-error';

$(() => {
    //const common = new Common();
    //common.init();

	const layout = new Layout();
    layout.init();

    const analytics = new Analytics();
    analytics.init();
});
